import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  informationMax: {
    maxWidth: "20%",
    "@media (max-width: 1000px)": {
      maxWidth: "50%",
      marginBottom: "12px",
    },
  },

  content: {
    padding: "0px 24px",
  },

  contentTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "14px",
    color: "#308CDB",
    lineHeight: "24px",
    marginBottom: "4px",
  },
  contentValue: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#465869",
    lineHeight: "24px",
  },
  contentEmpty: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#9CA6AF",
    lineHeight: "24px",
  },

  contentBadge: {
    width: "auto",
  },
  simpleBadgeText: {
    color: "#308CDB",
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  containerTaskStatus: {
    display: "flex",
    gap: "16px",
  },
  badgeTaskStatus: {
    height: "24px",
  },

  simpleTagBadge: {
    ...getSimpleBadgeStyles("80px"),
  },
  simpleFleetBadge: {
    ...getSimpleBadgeStyles("110px"),
  },
  simpleStaffBadge: {
    ...getSimpleBadgeStyles("110px"),
  },
}));

export default styles;

export const getSimpleBadgeStyles = (width: string) => ({
  background: "#EDF5FB",
  borderRadius: "8px",
  height: "28px",
  padding: "4px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0px 8px 8px 0px",
  minWidth: width,
  maxWidth: width,
});
